/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from "styled-components";
import Button from "components/Buttons/ThemeButton";

export const Container = styled.div`
	font-size: 1rem;
	width: 100%;
	height: 3.81em;
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);
	padding: 0.38em;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 0.2em;
	//gap: 0.7em;

	@media (min-width: 900px) {
		max-width: 60%;
	}
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.7em;
	flex: 1;
	min-width: 0;
`;

export const FriendImage = styled.div`
	width: 2.1em;
	height: 2.1em;
	background-size: cover;
	flex-shrink: 0;
`;

export const FriendName = styled.div`
	font-family: Baloo;
	color: #333;
	font-size: 1em;
	font-style: normal;
	font-weight: 400;
	line-height: 1.125em;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const FriendActivity = styled.div`
	color: #907363;
	font-family: Inter;
	font-size: 0.75em;
	font-style: normal;
	font-weight: 700;
	line-height: 1em;
`;

export const FriendText = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
`;

export const CustomButton = styled(Button)`
	width: 7.44em;
	height: 2.8em;
	font-size: 1em;
	white-space: nowrap;
	//text-transform: none;
`;
